import { Search, Mic } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SearchPillProps {
  placeholder?: string;
  className?: string;
}

export function SearchPill({
  placeholder = 'Buscar lançamentos, prestações, fornecedores…',
  className,
}: SearchPillProps) {
  return (
    <div
      className={cn(
        'flex h-[46px] w-full min-w-0 max-w-[480px] items-center gap-3 rounded-pill',
        'border border-card-stroke bg-card-soft pl-5 pr-1 py-1',
        'shadow-pressed',
        className,
      )}
    >
      <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-card-stroke bg-frame text-fg-muted">
        <Search className="h-3.5 w-3.5" strokeWidth={1.8} />
      </span>
      <input
        type="search"
        placeholder={placeholder}
        className="min-w-0 flex-1 border-0 bg-transparent text-sm text-fg outline-none placeholder:text-fg-dim"
      />
      <button
        type="button"
        aria-label="Busca por voz"
        className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-ink text-white"
      >
        <Mic className="h-3.5 w-3.5" strokeWidth={1.8} />
      </button>
    </div>
  );
}
